import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-collapsable" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "text",
      class: _normalizeClass(["text-content", { 'text-collapsed': $options.is_collapsed && $data.needs_collapse }]),
      style: _normalizeStyle({ 'max-height': $options.is_collapsed ? $data.max_height + 'px' : null }),
      innerHTML: _ctx.content
    }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_2),
    ($data.needs_collapse && !_ctx.selector)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.link ? 'text-start pt-0' : 'text-center pt-3')
        }, [
          _createElementVNode("a", {
            class: _normalizeClass(_ctx.link ? 'text-muted small' : 'btn btn-outline-light'),
            href: "#",
            onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($options.toggle()), ["prevent","stop"]))
          }, [
            _createTextVNode(_toDisplayString($data.expanded ? $options.translations.actions.HIDE : $options.translations.actions.SHOW_ALL) + " ", 1 /* TEXT */),
            _createVNode(_component_icon, { name: "ARROW_RIGHT" })
          ], 2 /* CLASS */)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ]))
}